import { Component, OnInit, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'src/app/core/constants/app-constants';
import { OrderConstants } from 'src/app/core/constants/order-constants';
import { OrderModel } from 'src/app/store/order/model';

@Component({
  selector: 'app-order-tab-files',
  templateUrl: './order-tab-files.component.html',
  styleUrls: ['./order-tab-files.component.scss'],
  standalone: false,
})
export class OrderTabFilesComponent implements OnInit {
  translate = inject(TranslateService);

  @Input() order: OrderModel;

  uploadUrlData: string;
  showInfo: boolean;

  ngOnInit(): void {
    this.uploadUrlData = `/api/orders/${this.order.id}/files`;
  }

  getUrlById(id: number): string {
    return `/api/orders/${id}/getFile`;
  }

  getMaxFileSize(): number {
    return OrderConstants.MaxFileSize;
  }

  getSupportedFileFormat(): string[] {
    return OrderConstants.SupportedFileFormat;
  }

  getSupportedFileFormatString(): string {
    return OrderConstants.SupportedFileFormat.join(', ');
  }

  info() {
    this.showInfo = true;
  }

  isFilesSelected() {
    return Array.isArray(this.order.addedFiles) && this.order.addedFiles.length ? true : false;
  }

  unselectAllFiles() {
    this.order.addedFiles = [];
  }
}
